import {
  Component,
  ElementRef,
  Type,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { PrFormAbstract } from '../pr-form.abstract';
import { PrFormService } from '../pr-form.service';
import { PrFormHostDirective } from './pr-form-host.directive';

@Component({
    selector: 'pr-form-container',
    templateUrl: './pr-form-container.component.html',
    styleUrls: ['./pr-form-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrFormContainerComponent {
  @ViewChild('wrapper') public wrapper: ElementRef;
  @ViewChild(PrFormHostDirective, { static: true })
  container!: PrFormHostDirective;
  load: boolean = false;
  opened: boolean = false;

  constructor(
    private service: PrFormService,
  ) {
    this.service.container = this;
  }

  loading() {
    this.load = true;
  }

  loaded() {
    this.load = false;
  }

  open(type: Type<any>, parameters: any, callback?, options?) {
    this.loading();
    this.wrapper.nativeElement.classList.add('active');
    setTimeout(() => {
      this.wrapper.nativeElement.classList.add('open');
    }, 100);
    let component = this.createComponent(type, parameters, callback, options);
    this.loaded();
    return component;
  }

  createComponent(type: Type<any>, entity: any, callback?, options?) {
    const viewContainerRef = this.container.viewContainerRef;
    viewContainerRef.clear();

    const componentRef =
      viewContainerRef.createComponent<PrFormAbstract>(type);
    if (entity) {
      componentRef.instance.initForm(entity, options);
    } else {
      componentRef.instance.initForm({}, options);
    }
    if (callback) {
      componentRef.instance.initCallback(callback);
    }
    return componentRef.instance;
  }

  close() {
    this.wrapper.nativeElement.classList.remove('open');
    setTimeout(() => {
      const viewContainerRef = this.container.viewContainerRef;
      viewContainerRef.clear();
      this.wrapper.nativeElement.classList.remove('active');
    }, 400);
  }
}
